import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-body1" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "q-mb-sm" }, " Here is the API key that you need to add to Litify: ", -1)
const _hoisted_3 = { class: "q-mt-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_q_input, {
      label: "API Key",
      "model-value": _ctx.value,
      outlined: "",
      readonly: ""
    }, {
      append: _withCtx(() => [
        _createVNode(_component_q_btn, {
          icon: "fa fa-copy",
          label: "Copy",
          rounded: "",
          flat: "",
          onClick: _ctx.copy
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_q_icon, {
        name: "fa fa-exclamation-triangle",
        color: "warning"
      }),
      _createTextVNode(" This is the only time we will show you this key. ")
    ])
  ]))
}